export const SET_PROPERTY_PROVEEDOR = "SET_PROPERTY_PROVEEDOR";
export const PROVEEDORES_RECEIVED = "PROVEEDORES_RECEIVED";
export const CREATE_PROVEEDOR = "CREATE_PROVEEDOR";
export const UPDATE_PROVEEDOR = "UPDATE_PROVEEDOR";
export const DELETE_PROVEEDOR = "DELETE_PROVEEDOR";
export const SET_PROVEEDOR = "SET_PROVEEDOR";
